import {StyleSheet} from "aphrodite";

import {CompactCell} from "@khanacademy/wonder-blocks-cell";
import {View} from "@khanacademy/wonder-blocks-core";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";

const StateStandardsBanner = () => {
    return (
        <View style={styles.calloutContainer}>
            <CompactCell
                title="Find content that matches your state standards >"
                href="/regions/united-states"
                horizontalRule="none"
                style={styles.calloutCell}
                active={true}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    calloutContainer: {
        paddingTop: spacing.xxSmall_6,
        paddingBottom: spacing.medium_16,
        paddingLeft: spacing.xxSmall_6,
        paddingRight: spacing.xxSmall_6,
    },
    calloutCell: {
        textAlign: "center",
        padding: spacing.medium_16,
        color: color.offBlack,
    },
});

export default StateStandardsBanner;
